import { Entity, IField } from "@/app/fields/types";
import { useFormContext } from "@saas-ui/forms";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form/dist/types/fields";

export const useOnFieldChange = <T extends Entity>({
  field,
  on_change,
  on_change_fields = [],
}: IField<T>) => {
  const {
    watch,
    formState: { dirtyFields },
    reset,
  } = useFormContext();
  const fieldName = String(field);
  const changedValues = watch(on_change_fields);
  useEffect(() => {
    if (!on_change) {
      return;
    }
    if (
      on_change_fields.filter((f) => Object.keys(dirtyFields).includes(f))
        .length > 0
    ) {
      const onChangeFn = eval(on_change) as (prev: FieldValues) => FieldValues;
      reset(onChangeFn);
    }
  }, [changedValues]);
};
